import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core'

@Component({
  selector: 'app-color-boxes',
  templateUrl: './color-boxes.component.html',
  styleUrls: ['./color-boxes.component.scss'],
})
export class ColorBoxesComponent {
  @Input() colors: string[]
  @Input() activeColor: string
  @Input() isDisabled: boolean = false

  @Output() change = new EventEmitter<string>()

  @HostBinding('class.clearfix') clearfix = true

  onSelect(color: string) {
    if (this.isDisabled) {
      return
    }
    this.activeColor = color
    this.change.emit(color)
  }
}
